module.exports = __webpack_public_path__ + "static/media/linkedinicon.2ce9c7e9.png";